import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import payouts from '../../models/payouts'
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {Add, Payments} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink, useSearchParams} from "react-router-dom";
import Pagination from "../Pagination";
import {AclRouterLink} from "../ACL";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';

export default function PayoutIndex() {
    const [searchParams] = useSearchParams()
    const [payoutsData, setPayoutsData] = useState(null)
    const {setShowLoader, userData} = useRootHook()

    const page = Math.max(1, parseInt(searchParams.get('page') || '1', 10) || 1)

    useEffect(() => {
        setShowLoader(true)
        payouts.index({page})
            .then((data) => {
                data && setPayoutsData(data)
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [page, setShowLoader])

    if (!payoutsData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Payouts"
                breadcrumbs={[['Dashboard', '/'], ['Payouts', '/payouts']]}
                actions={
                    <>
                        <Button to="/payouts/add" component={AclRouterLink} variant="contained" startIcon={<Add />}>
                            Add payout
                        </Button>
                        <Button to="/payout-methods" component={AclRouterLink} variant="outlined" startIcon={<Payments />}>
                            Payout methods
                        </Button>
                    </>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto'}}>
                <TableToolbar title="Payouts" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            {userData.role !== helpers.roles.M && <TableCell>Merchant</TableCell>}
                            <TableCell>Method</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Amount Net</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Wallet Address</TableCell>
                            <TableCell>Added</TableCell>
                            <TableCell align="right">Modified</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payoutsData.payouts.map((row) => (
                            <TableRow key={`payout-${row.id}`}>
                                <TableCell>
                                    {
                                        userData.role !== helpers.roles.M ?
                                        <Link to={`edit?id=${row.id}`} component={RouterLink}>
                                            {row.id}
                                        </Link>
                                        :
                                        row.id
                                    }

                                </TableCell>
                                {userData.role !== helpers.roles.M
                                    && <TableCell>{row['merchant.name']}</TableCell>
                                }
                                <TableCell>{row['payout_method.name']}</TableCell>
                                <TableCell>
                                    {helpers.subunitAmount(row.amount_total, userData.defaultCurrency.subunit)}
                                </TableCell>
                                <TableCell>
                                    {helpers.subunitAmount(row.amount, userData.defaultCurrency.subunit)}
                                </TableCell>
                                <TableCell>{row.status}</TableCell>
                                <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }} title={row.wallet_address || ''}>
                                    {row.wallet_address || '—'}
                                </TableCell>
                                <TableCell>{helpers.getDateTime(row.created)}</TableCell>
                                <TableCell align="right">{helpers.getDateTime(row.modified)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Pagination url={'/payouts'} count={payoutsData.count}/>
            </SectionCard>
        </Grid>
    </React.Fragment>
}

